module.exports = __webpack_public_path__ + "static/media/bagy7.37b9e85a.png";